import { gql } from '@apollo/client';

export const ALL_INSTITUTION_PORTAL_USERS = gql`
  query AllInstitutionPortalUsers($input: UserFilterInput!) {
    users: allInstitutionPortalUsers(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          createdAt
          id
          updatedAt
          email
          firstName
          lastName
          status
          contactNumber
          designation
          lastLogin
          authMetaData {
            id
            duration
          }
          organisations {
            id
            status
            role {
              id
              name
            }
            practitionerType
            organisation {
              id
              isInstitution
              institution {
                id
              }
            }
          }
        }
      }
    }
  }
`;
